import { BpSubpage } from 'components/BpSubpage/BpSubpage';
import { usePermissionChecker } from 'hooks/usePermissionChecker';
import { useRequireParams } from 'hooks/useRequireParams';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AssignmentForm } from '../../../components/Assignments/forms/AssignmentForm';
import { useAuthClaims } from '../../../hooks/useAuthClaims';
import { CourseSubmissionStudentContent } from './StudentContent/CourseSubmissionStudentContent';
import { CourseAssignmentTeacherContent } from './TeacherContent/CourseAssignmentTeacherContent';

export const CourseAssignmentSubpage = () => {
  const { pimAuthClaims } = useAuthClaims();
  const navigate = useNavigate();
  const { courseUuid, assignmentUuid } = useRequireParams(['courseUuid', 'assignmentUuid']);

  const permissions = usePermissionChecker();

  const [loading, setLoading] = useState<boolean>(false);
  const [edit, setEdit] = useState<boolean>(false);

  function handleEdit() {
    setEdit(true);
  }

  function handleClose() {
    setEdit(false);
  }

  function handleNavigateToPublicSubmission() {
    navigate(`/courses/${courseUuid}/assignments/${assignmentUuid}/submissions/public`);
  }

  const canCreate = permissions?.canCreateAssignment({
    uuid: courseUuid,
    organization: { uuid: pimAuthClaims.getOrganizationUuid() },
  });

  return (
    <BpSubpage loading={loading}>
      {canCreate ? (
        edit ? (
          <AssignmentForm
            assignmentUuid={assignmentUuid}
            onLoad={(loading) => setLoading(loading)}
            onClose={() => handleClose()}
          />
        ) : (
          <CourseAssignmentTeacherContent assignmentUuid={assignmentUuid} onEdit={() => handleEdit()} />
        )
      ) : (
        <CourseSubmissionStudentContent
          assignmentUuid={assignmentUuid}
          onNavigate={() => handleNavigateToPublicSubmission()}
        />
      )}
    </BpSubpage>
  );
};
